<template>
    <div class='marking content-view'>
        <menus />

        <h2 class='fs-24 text-center fc-theme'>抖音黑科技卡首屏</h2>
        <p class='subtitle text-center fs-14 fc-666'>主要用于提供快速卡榜单入口，提高渠道入口权重</p>
        <p v-if='$store.state.phone' class='top-tip fc-333 fs-14'>
            <i class='el-icon-s-opportunity'></i>
            <span style='padding-right: 6px;'>会员VIP<span class='fc-theme'>{{ pricePreMonth.vip_point }}</span> 点券/次，非会员VIP<span class='fc-theme'>{{ pricePreMonth.point }}</span>点券/次</span>
            <el-button v-if='!userData.is_vip' size='mini' type='danger' @click="$bus.emit('openVip', configData)">开通VIP</el-button>
        </p>
        <p v-else class='top-tip fc-333 fs-14'>
            <i class='el-icon-s-opportunity'></i>
            <span>注册即可获得免费试用{{ pricePreMonth.month_given_num }}次<span v-if='!userData.is_vip' class='fc-theme point' @click="$bus.emit('openReg', configData)">点击注册</span></span>
        </p>
        <el-alert type='error' :closable='false' class='marginT-20'>
            <div slot='title' class='pause-top-tip'>
                功能说明：<br>
                这个方法可以帮助到你的流量入口为【商城推荐流量】目前权重也是较高；<br>
                根据我们的方法来操作并在{{isToolMainSite() ? 'V兔' : '电商'}}生成二维码， 通过这个入口操作， 第二天的商品来源会来自【商品榜单流量】
            </div>
        </el-alert>
        <div>
            <div class='flex'>
                <div class='flex-1' style='padding-right: 20px;'>
                    <el-form class='marginT-50' label-width='100px' label-position='left'>
                        <el-form-item label='宝贝链接：'>
                            <el-input type='text' v-model='form.url' placeholder='请输入您的宝贝链接或宝贝ID'></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button class='item' type='danger' :loading='btnLoading' @click='onSubmit'>点击生成二维码</el-button>
                        </el-form-item>
                    </el-form>
                    <div v-show='showQr' class='showqrcode flex'>
                        <div class='qrcode' ref='qrcode' id='qrcode'></div>
                    </div>
                </div>
                <div style='width: 420px;'>
                    <tip-info :info='pricePreMonth' />
                </div>
            </div>
            <div>
                <img style='width: 100%;' :src="require('@/index/assets/img/shili.jpg')" alt='' />
            </div>
        </div>
        <div>
            <record ref="recordRef" />
        </div>
    </div>
</template>

<script>
import mixin from '../../mixin/pagination'
import { mapState } from 'vuex'
import TipInfo from './TipInfo'
import QRCode from 'qrcodejs2'
import Record from './Record';
import Menus from "../first_flow/_components/Menus"

export default {
    mixins: [mixin],
    computed: mapState(['userData', 'configData', 'phone']),
    components: {
        TipInfo,
        Record,
        Menus,
    },
    data() {
        return {
            tableData: [],
            pricePreMonth: {},
            form: {
                url: '' // 宝贝链接
            },
            showQr: false,
            btnLoading: false,
            tableUrl: '/tool/accounts/api-record'
        }
    },
    mounted() {
        if (localStorage.token) {
            this.init()
        }
        this.priceLimit()
    },
    methods: {
        async priceLimit() {
            const data = await this.$fetch('/api/proxy/web/tool/detail', { name: 'dykashoup' })
            this.pricePreMonth = data.data
        },
        async onSubmit() {
            if (!localStorage.token) {
                this.$bus.emit('openLogin')
                return false
            }

            this.$alert('该功能因官方升级暂无法使用，正在努力解决中', '提示', {
                confirmButtonText: '确定',
                callback: action => {}
            });
            return 0;

            if (!this.form.url) {
                this.$message.error('请输入宝贝链接')
                return false
            }

            this.btnLoading = true;
            const res = await this.$fetch('/api/proxy/web/dykashoup', { ...this.form }, 'post')
            this.btnLoading = false;

            if (res.code == 0) {
                const { url } = res.data;

                this.showQr = true;
                this.qrcode(url)
                this.$refs.recordRef.searchSubmit()
            }
        },
        // 生成二维码
        qrcode(data) {
            if (this.$refs.qrcode) {
                this.$refs.qrcode.innerHTML = ''
            }

            let qrcode = new QRCode('qrcode', {
                width: 320,
                height: 320,
                text: data,
                // correctLevel : QRCode.CorrectLevel.Q
                // correctLevel: QRCode.CorrectLevel.L
                correctLevel: 3,

            })
            this.$refs.qrcode.removeAttribute('title')
            setTimeout(() => {
                this.$refs.qrcode.removeAttribute('title')
            }, 100)
        },
    }
}
</script>

<style lang="scss" scoped>
.pause-top-tip {
    color: #ff6600;
    padding: 10px 0;
}
.showqrcode {
    align-items: flex-end;
    justify-content: center;
}
.box-card {
    margin-top: 25px;
    .li-content {
        line-height: 24px;
        color: #999;
    }
}
.qrcode {
    margin: 10px 30px;
}
.item + .item {
    margin-left: 20px;
}
</style>
<style lang="scss">
.tip-card .el-card__header {
    padding: 10px 20px;
    color: #666;
}
.item {
    .el-badge__content.is-fixed {
        right: 0;
        top: 0;
        transform: translateY(-50%) translateX(50%)
    }
}
.bg-none {
    .el-button--danger.is-plain {
        background: none;
    }
    .el-button--danger.is-plain:focus {
        background: #F56C6C;
    }
}
.bg-none:hover {
    .el-button--danger.is-plain {
        background: #F56C6C;
    }
}
</style>
